import { Component, OnInit, Input } from '@angular/core';
import { WMAIApiService, Experience } from '../../core';
import { Angulartics2 } from 'angulartics2';
import { WgisService } from 'src/app/wgis/wgis.service';
import { TranslateService } from '@ngx-translate/core';
import { ModalSize, SuiModalService } from 'ng2-semantic-ui';
import { SimpleModal } from 'src/app/core/templates';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-esperienza-preview',
  templateUrl: './esperienza-preview.component.html',
})
export class EsperienzaPreviewComponent implements OnInit {

  @Input() esperienza: Experience;
  
  constructor(
    private wgis: WgisService,
    private wmaiservice: WMAIApiService,
    private angulartics2: Angulartics2,
    private translateService: TranslateService,
    private modalService: SuiModalService
  ) { 
    this.angulartics2.eventTrack.next({ 
      action: 'onShare', 
      properties: {label : 'EsperienzaPreviewShare' },
    });

  }


  onShare(){
    this.wmaiservice.share(this.esperienza['id']).subscribe(data => {
      // console.log("resp", data);
      if(data.length == 0){
        this.showSimpleModal('modal.esperienza.like.title','modal.esperienza.like.need_login');
      } else if(data.share == '-1'){
        this.showSimpleModal('modal.esperienza.like.title','modal.esperienza.like.limit');
      } else {
        this.esperienza.share = data.share
      }
    }, error => {
      this.showSimpleModal('modal.esperienza.like.title','modal.esperienza.like.error');
    })
  }

  zoomOn(esperienza: Experience){
    this.wgis.showEsperienzaByObj(esperienza);
  }

  showSimpleModal(title: string, content: string){
    let titlec: string = this.translateService.instant(title);
    let contentc: string = this.translateService.instant(content);
    this.modalService
      .open(new SimpleModal(titlec, contentc, ModalSize.Tiny))
      .onApprove(() => {
      })
  }

  ngOnInit(){
  }
}
